import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { EquipmentDataTable } from 'modules/job_catalog/components/EquipmentDataTable'
import {
  getChildNodeType,
  getValidNodeIdFromParams,
  normalizeNodeType,
} from 'modules/job_catalog/lib/nodesUtils'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

export const ItManagementPage = () => {
  const { rootId, familyId, functionId, roleId, levelId } = useParams()
  const id = getValidNodeIdFromParams(levelId, roleId, functionId, familyId, rootId)
  const childType = getChildNodeType(id)
  const nodeType = normalizeNodeType(id)

  useEffect(() => {
    if (!id) return
    track(trackingEvents.jobCatalog.navigateNodeSubmit, {
      event_category: 'Organizations',
      node_type: normalizeNodeType(id),
      node_id: id,
      tab: 'it_management',
    })
  }, [id])

  return (
    <ResponsivePage.Body variant="full">
      {!!id && <EquipmentDataTable nodeId={id} nodeType={nodeType} childType={childType} />}
    </ResponsivePage.Body>
  )
}
